import Separator from './container';

export default Separator;
